export default __webpack_public_path__ + "static/media/infinity-solid.74f97d38.svg";